import { useState, useEffect, useRef } from "react";

// JD Creation Messages (for AIModal when creating/improving JD)
const JD_CREATION_MESSAGES = [
  "Grabbing a virtual coffee before writing",
  "Running job description generator",
  "Analysing requirements",
  "Compiling requirements into opportunity",
  "Mapping responsibilities",
  "Identifying key skills",
  "Optimizing role clarity",
  "Connecting with the hiring manager dimension",
  "Refining expectations",
  "Translating thoughts into hiring language",
  "Convincing the AI that weekends are not a skill...",
  "Helping future stars find their way to you",
  "Thinking like a recruiter, writing like a marketer",
  "Polishing the description",
  "Adding just some magic",
  "Generating fewer buzzwords than usual",
  "Readying your next hire",
  "Convincing AI not to write a novel",
  "One moment, worth the wait",
  "Creating something candidates will notice",
  "Building candidate appeal",
  "Drafting the opportunity",
  "Generating hiring magic",
  "Launching your next great hire"
];



const RESUME_PARSING_MESSAGES  = [
  // Early phase (warm-up / parsing)
  "Hang tight, AI is thinking...",
  "Your document is in good hands…",
  "Give us a moment while we work our magic…",
  "Analyzing document structure...",
  "Scanning sections and headings...",
  "Reading through your resume...",
  "This resume has character.",
  "Interesting resume… analysing further 👀",
  "Identifying key segments...",
  "Scanning for brilliance…",
  "Someone’s been busy 👏",
  "Reading between the bullet points…",

  // Mid phase (core processing)
  "Extracting important details...",
  "Understanding your work experience...",
  "Your experience section came prepared.",
  "Analysing achievements and humble brags…",
  "Mapping roles and responsibilities...",
  "Cross-referencing your skills & roles...",
  "Detecting relevant technologies...",
  "Interpreting project information...",
  "Matching experience to known patterns...",
  "Organizing extracted data...",
  "Structuring professional timeline...",
  "Analyzing your professional plot twists…",
  "Converting document into career intelligence…",
  "Your resume and our AI are having a meeting.",
  "Analyzing skills, experience, and suspiciously high productivity…",
  "Your bullet points are under investigation.",
  "Searching for the secret ingredient: impact.",
  "Making sense of corporate acronyms…",

  // Deep processing (LLM-heavy feel)
  "Refining extracted insights...",
  "Validating context and accuracy...",
  "Resolving ambiguous entries...",
  "Aligning data with standard formats...",
  "Processing ambition, confidence, and caffeine…",
  "Detecting traces of leadership…",
  "Cross-checking buzzwords with reality…",
  "Evaluating your main-character energy…",
  "This resume might actually impress HR.",
  "The AI has opinions already.",
  "Looking for ‘team player’… found it.",
  "Optimizing structured output...",
  "This could’ve been an email. Good thing it’s a resume.",

  // Late phase (closing)
  "Almost there, finalizing extraction...",
  "Cleaning up the results...",
  "Preparing final structured data...",
  "Running final validation checks...",
  "Wrapping up, one moment...",
];
const ConicLoader = () => (
  <div className="loader text-text-primary" />
);


const RegenLoader = ({ progress, messageType = "resume" }) => {
  const MESSAGES = messageType === "jd" ? JD_CREATION_MESSAGES : RESUME_PARSING_MESSAGES;
  const [displayMsg, setDisplayMsg] = useState(
    progress?.message || MESSAGES[0]
  );
  const [visible, setVisible] = useState(true);

  const fakeTimer = useRef(null);
  const msgTimer = useRef(null);
  const msgIdx = useRef(0);

  function stopTimers() {
    clearInterval(fakeTimer.current);
    clearInterval(msgTimer.current);
  }

  function cycleMessage() {
    setVisible(false);
    setTimeout(() => {
      msgIdx.current = (msgIdx.current + 1) % MESSAGES.length;
      setDisplayMsg(MESSAGES[msgIdx.current]);
      setVisible(true);
    }, 300);
  }

  function startCycling() {
    stopTimers();
    msgTimer.current = setInterval(cycleMessage, 4000);
  }

  useEffect(() => {
    const pct = progress?.percentage ?? 0;
    const msg = progress?.message;

    if (msg) {
      setVisible(false);
      setTimeout(() => {
        setDisplayMsg(msg);
        setVisible(true);
      }, 300);
    }

    if (pct === 100) {
      stopTimers();
      setVisible(false);
      setTimeout(() => {
        setDisplayMsg("Finalizing...");
        setVisible(true);
      }, 300);
    } else {
      startCycling();
    }

    return () => stopTimers();
  }, [progress]);

  return (
  <div className="flex flex-col items-center justify-center py-12 gap-8">
    <ConicLoader />
    <p
      className="text-sm text-center max-w-[280px] leading-relaxed min-h-[44px] flex items-center justify-center text-text-primary"
      style={{
        opacity: visible ? 1 : 0,
        transition: "opacity 0.3s ease",
      }}
    >
      {displayMsg}
    </p>
  </div>
);
};

export default RegenLoader;